module.exports = "/_next/static/images/box man-3ef7100c103f904d1854780e3bc82610.svg";